import { HeadData } from '@/components/HeadData';
import { useFragment } from '@/gql/codegen';
import { graphql } from '@/gql/codegen/gql';
import { useSuspenseQuery } from '@apollo/client';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { SkillCheckTestContainer } from './-container';

export const GET_COURSE_SKILL_CHECK_TEST = graphql(/* GraphQL */ `
  query EmbaCourseSkillCheckTest($embaUserAttendanceSlug: String!) {
    embaCourseSkillCheckTest(embaUserAttendanceSlug: $embaUserAttendanceSlug) {
      ...EmbaCourseSkillCheckTestForPageLoader
      embaCourse {
        name
      }
    }
  }
`);

export const COURSE_SKILL_CHECK_TEST_FOR_PAGE_LOADER = graphql(/* GraphQL */ `
  fragment EmbaCourseSkillCheckTestForPageLoader on CourseSkillCheckTest {
    latestResult {
      id
      isAllCorrect
    }
    ...EmbaCourseSkillCheckTest
  }
`);

type SkillCheckTestSearch = {
  retry: boolean;
};

export const Route = createFileRoute(
  '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/skill-check-test/',
)({
  component: component,
  validateSearch: (search: Record<string, unknown>): SkillCheckTestSearch => {
    // validate and parse the search params into a typed state
    return {
      retry: search.retry as boolean,
    };
  },
});

function component() {
  const navigate = useNavigate();

  const { userAttendanceSlug } = Route.useParams();

  const { retry } = Route.useSearch();

  const { error, data } = useSuspenseQuery(GET_COURSE_SKILL_CHECK_TEST, {
    variables: {
      embaUserAttendanceSlug: userAttendanceSlug,
    },
  });

  if (error) {
    throw error;
  }

  const skillCheckTestData = useFragment(
    COURSE_SKILL_CHECK_TEST_FOR_PAGE_LOADER,
    data.embaCourseSkillCheckTest,
  );

  useEffect(() => {
    // 全問正解の場合は結果ページに遷移
    if (skillCheckTestData.latestResult?.isAllCorrect) {
      navigate({
        to: '/user-attendances/$userAttendanceSlug/skill-check-test/result',
        params: {
          userAttendanceSlug,
        },
        search: {
          timeUp: false,
        },
        replace: true,
      });
    }
  }, [navigate, skillCheckTestData, userAttendanceSlug]);

  return (
    <>
      <HeadData title={data.embaCourseSkillCheckTest.embaCourse.name} />
      <SkillCheckTestContainer
        embaCourseSkillCheckTest={skillCheckTestData}
        userAttendanceSlug={userAttendanceSlug}
        retry={retry}
      />
    </>
  );
}
